import { Button } from "@/components/ui/button";
import { CampaignConfig } from "@/lib/campaigns";

interface WaitlistMessageProps {
  campaign: CampaignConfig;
}

const WaitlistMessage = ({ campaign }: WaitlistMessageProps) => {
  const eventUrl = `/events/${campaign.targetEventId}`;

  return (
    <div className="fixed bottom-20 left-0 right-0 bg-white border-t border-gray-100 p-4">
      <div className="max-w-md mx-auto text-center space-y-4">
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
          <p className="text-sm text-orange-800 mb-3">
            {campaign.message}
          </p>
          
          <Button 
            asChild
            className="w-full bg-orange-600 hover:bg-orange-700 text-white mb-3"
          >
            <a href={eventUrl}>
              {campaign.ctaText}
            </a>
          </Button>
          
          <div className="bg-white border border-orange-300 rounded p-3">
            <p className="text-xs text-orange-700 mb-1">Use promo code at checkout:</p>
            <p className="text-lg font-bold text-orange-800 tracking-wider">SALON50</p>
            <p className="text-xs text-orange-600 mt-1">
              for {campaign.discountPercent}% off
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitlistMessage;